import React from 'react';
import { PhoneCallIcon } from 'lucide-react';
const links = [{
  label: 'Términos de Servicio',
  href: '#terminos'
}, {
  label: 'Política de Privacidad',
  href: '#privacidad'
}, {
  label: 'Contacto',
  href: '#contacto'
}];
export function Footer() {
  return <footer className="w-full bg-night py-14 text-white md:py-16" data-id="element-66" data-mp="32m1aiwl92wnk">
      <div className="mx-auto w-full max-w-narrow px-5 text-center md:px-8" data-id="element-67" data-mp="36pzatambadi7">
        <p className="inline-flex items-center gap-2.5 font-display text-sm font-extrabold uppercase tracking-[0.14em] text-amber-400 md:text-base" data-id="element-68" data-mp="3ug3f7k7bqha9">
          <span className="h-3 w-3 rounded-full bg-amber-400 ring-4 ring-amber-400/20" aria-hidden="true" data-id="element-69" data-mp="36d3qyjl4vnu" />
          Protocolo Septiembre Amarillo™
        </p>

        <p className="mt-6 text-sm text-gray-400" data-id="element-70" data-mp="3qfjfc8vd8zkf">
          © 2026 Protocolo Septiembre Amarillo™ | Todos los derechos reservados
        </p>

        <p className="mt-6 inline-flex items-center gap-2 rounded-xl bg-gray-900 px-4 py-2.5 text-sm font-semibold text-amber-400 ring-1 ring-gray-800" data-id="element-71" data-mp="2eyjrbpg1x6w7">
          <PhoneCallIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-72" data-mp="3lbmw5xyxdiij" />
          Si estás en crisis, contactá a la Línea 135 (Argentina)
        </p>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-sm text-gray-300" data-id="element-73" data-mp="3v8rh5uh1b7xr">
          {links.map(link => <li key={link.label} data-id="element-74" data-mp="3qazr75zy9vw7">
              <a href={link.href} className="transition-colors duration-150 ease-calm hover:text-amber-400" data-id="element-75" data-mp="82icbryzq8eb">
                {link.label}
              </a>
            </li>)}
        </ul>

        <p className="mt-10 border-t border-gray-800 pt-6 text-xs leading-relaxed text-gray-500" data-id="element-76" data-mp="hs1yp7lwwkdx">
          Este producto es con fines exclusivamente educativos y de concientización. El uso de estos
          recursos no sustituye la terapia profesional, el diagnóstico clínico ni la intervención
          médica. El autor no se hace responsable por el uso indebido de las dinámicas grupales.
        </p>
      </div>
    </footer>;
}